import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import o from "../core/Accessor.js";
import e from "../core/Collection.js";
import { HandleOwner as i } from "../core/HandleOwner.js";
import { makeHandle as s } from "../core/handleUtils.js";
import r from "../core/Logger.js";
import { isSome as a, isNone as l, destroyMaybe as n } from "../core/maybe.js";
import { watch as h } from "../core/watchUtils.js";
import { property as c } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";
import { TextureCollection as u } from "./3d/support/TextureCollection.js";
import { ViewEventPriorities as d } from "./input/InputManager.js";
import { eventTypes as v } from "./input/ViewEvents.js";
import { getToolAttachDetachHandles as m, areToolManipulatorsEditable as f } from "./interactive/interactiveToolUtils.js";
import T from "./interactive/ToolViewManagerManipulatorState.js";

var _ = r.getLogger("esri.views.ToolViewManager"),
    E = "attached",
    w = "tools";

var g = /*#__PURE__*/function (_i) {
  _inherits(g, _i);

  var _super = _createSuper(g);

  function g(t) {
    var _this;

    _classCallCheck(this, g);

    _this = _super.call(this, t), _this._manipulatorState = new T(), _this.tools = new e(), _this.cursor = null, _this._forEachTool = function (t) {
      var _iterator = _createForOfIteratorHelper(_this.tools.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _o = _step.value;
          if (t(_o)) return;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    return _this;
  }

  _createClass(g, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.handles.add([this.view.on(v, function (t) {
        _this2._handleInputEvent(t);
      }, d.TOOL)].concat(_toConsumableArray(m(this.tools)), [this.tools.on("before-add", function (t) {
        var o = t.item;
        if (null == o || _this2.tools.includes(o)) return _.warn("Tool is either already in the list of tools or tool is `null`. Not adding tool."), void t.preventDefault();
      }), this.tools.on("before-remove", function (_ref) {
        var t = _ref.item;

        _this2._manipulatorState.clearPointers(t, _this2._forEachTool);
      }), this.tools.on("change", function () {
        _this2._refreshToolWatchers();
      })]));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._forEachTool(function (t) {
        return t.destroy();
      });
    }
  }, {
    key: "activeTool",
    set: function set(t) {
      if (a(t) && !this.view.ready) return void _.error("Cannot set active tool while view is not ready.");
      if (t === this.activeTool) return void (a(t) && _.warn("Tool is already active - ignoring activation request."));
      a(this.activeTool) && this.activeTool.deactivate(), a(t) && t.activate(), this._set("activeTool", t), this._removeIncompleteTools(t);
      var o = l(this.activeTool);

      var _iterator2 = _createForOfIteratorHelper(this.tools),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e = _step2.value;

          _e.setEditableFlag(1, o || _e === this.activeTool);

          var _t = f(_e);

          !o && _t || this._manipulatorState.clearPointers(_e, this._forEachTool, !_t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._updateCursor();
    }
  }, {
    key: "updating",
    get: function get() {
      return this.updatingHandles.updating || this.tools.some(function (t) {
        return t.updating;
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      var _this3 = this;

      this._forEachTool(function (t) {
        return t.attach();
      }), "3d" === this.view.type ? (this._set("textures", new u(this.view._stage, this.view.resourceController.scheduler)), this.handles.add([this.view.state.watch("camera", function () {
        _this3._forEachManipulator(function (t) {
          null != t.onViewChange && t.onViewChange();
        });
      }), this.view.elevationProvider.on("elevation-change", function (t) {
        _this3._forEachManipulator(function (o) {
          null != o.onElevationChange && o.onElevationChange(t);
        });
      }), s(function () {
        return _this3._set("textures", n(_this3.textures));
      })], E)) : this.handles.add(this.view.watch("extent", function () {
        _this3._forEachManipulator(function (t) {
          null != t.onViewChange && t.onViewChange();
        });
      }));
    }
  }, {
    key: "detach",
    value: function detach() {
      a(this.activeTool) && (this.activeTool = null), this._forEachTool(function (t) {
        t.detach(), t.destroy();
      }), this.tools.removeAll(), this.handles.remove(E);
    }
  }, {
    key: "_forEachManipulator",
    value: function _forEachManipulator(t) {
      this._forEachTool(function (o) {
        o.manipulators && o.manipulators.forEach(function (_ref2) {
          var e = _ref2.manipulator;
          return t(e, o);
        });
      });
    }
  }, {
    key: "_handleInputEvent",
    value: function _handleInputEvent(t) {
      var _this4 = this;

      var o = !1;

      var e = _objectSpread(_objectSpread({}, t), {}, {
        stopPropagation: function stopPropagation() {
          o = !0, t.stopPropagation();
        }
      });

      a(this.activeTool) ? this.activeTool.handleInputEvent && this.activeTool.handleInputEvent(e) : this._forEachTool(function (t) {
        !o && t.attached && t.visible && t.handleInputEvent(e);
      }), !o && "key-down" === t.type && "Escape" === t.key && this.activeTool && (t.stopPropagation(), this.activeTool = null), this._manipulatorState.handleInputEvent(e, {
        forEachTool: this._forEachTool,
        activeTool: this.activeTool,
        setActiveTool: function setActiveTool(t) {
          _this4.activeTool = t;
        },
        view: this.view
      }), !o && a(this.activeTool) && this.activeTool.handleInputEventAfter(e), this._manipulatorState.handleHoverEvent(e, this._forEachTool), this._updateCursor();
    }
  }, {
    key: "_refreshToolWatchers",
    value: function _refreshToolWatchers() {
      var _this5 = this;

      this.handles.remove(w), this._forEachTool(function (t) {
        if (t instanceof o) {
          var _o2 = h(t, ["cursor", "visible", "editable"], function () {
            f(t) || _this5._manipulatorState.clearPointers(t, _this5._forEachTool), _this5._updateCursor();
          });

          _this5.handles.add(_o2, w);
        }

        t.manipulators && _this5.handles.add(t.manipulators.on("change", function (o) {
          o.removed.forEach(function (_ref3) {
            var o = _ref3.id;

            _this5._manipulatorState.clearPointers(t, _this5._forEachTool, !0, o);
          }), _this5._manipulatorState.updateHoveredStateFromKnownPointers(_this5._forEachTool), _this5._updateCursor();
        }), w);
      }), this._manipulatorState.updateHoveredStateFromKnownPointers(this._forEachTool), this._updateCursor();
    }
  }, {
    key: "_updateCursor",
    value: function _updateCursor() {
      var t = this._manipulatorState.cursor;
      this._forEachTool(function (o) {
        return !(!a(o.cursor) || !o.visible) && (t = o.cursor, !0);
      }), this._get("cursor") !== t && this._set("cursor", t);
    }
  }, {
    key: "_removeIncompleteTools",
    value: function _removeIncompleteTools(t) {
      var _this6 = this;

      this.tools.filter(function (o) {
        return (l(t) || o !== t) && !o.completed;
      }).forEach(function (t) {
        _this6.tools.remove(t), t.destroy();
      });
    }
  }]);

  return g;
}(i);

t([c({
  constructOnly: !0,
  nonNullable: !0
})], g.prototype, "view", void 0), t([c({
  readOnly: !0,
  nonNullable: !0
})], g.prototype, "textures", void 0), t([c({
  value: null
})], g.prototype, "activeTool", null), t([c({
  readOnly: !0,
  type: e
})], g.prototype, "tools", void 0), t([c({
  readOnly: !0
})], g.prototype, "cursor", void 0), t([c({
  readOnly: !0
})], g.prototype, "updating", null), g = t([p("esri.views.ToolViewManager")], g);
var y = g;
export { y as default };